// extracted by mini-css-extract-plugin
export default {"paper":"styles_paper__9c9ra","header":"styles_header__IuW-e","column":"styles_column__9Q0Ie","reversedColumn":"styles_reversedColumn__OfWJw"};